import { LANGUAGE_SELECTOR_PATH } from '../../guidedReg/constants';

const LANGUAGE_MASTERS = '/content/sunbeltrentals/language-masters/';
const FR_CA = 'fr-ca';

// CCA/POD form uses a suffix on author: /cca.html/personal-information
const PERSONAL_INFO = '/personal-information';

// e.g. /login/ -> true, /myaccount/quotes/ -> true, /cca/personal-information/ -> false
const isAccountPath = path => path.includes('/login') || path.includes('/myaccount');

// e.g. /fr-ca/cca/personal-information/ -> fr-ca, /createaccount/customer/ -> createaccount
const getLocale = path => path.split('/')[1];

// e.g. /fr-ca/..., /fr-CA/..., /fr_ca/..., /fr_CA/... -> true, /createaccount/... -> false
const isFrCa = path => getLocale(path).toLowerCase().replace('_', '-') === FR_CA;

// e.g. /content/sunbeltrentals/language-masters/fr_ca/cca.html -> /content/sunbeltrentals/language-masters/fr_ca
const getAuthorRoot = path => {
    if (!path.startsWith(LANGUAGE_MASTERS)) return '';
    const locale = path.replace(LANGUAGE_MASTERS, '').split('/')[0];
    return LANGUAGE_MASTERS + locale;
};

// e.g. with authorRoot .../language-masters/fr_ca
// /createaccount/personal/ -> .../fr_ca/createaccount/personal.html
// /cca/personal-information/ -> .../fr_ca/cca.html/personal-information
// .../language-masters/en/cca/application-error.html -> .../fr_ca/cca/application-error.html
const toAuthorPath = (path, authorRoot) => {
    if (path.startsWith(LANGUAGE_MASTERS)) return path.replace(getAuthorRoot(path), authorRoot);
    const page = path.endsWith('/') ? path.slice(0, -1) : path;
    if (page.endsWith(PERSONAL_INFO)) return authorRoot + page.replace(PERSONAL_INFO, `.html${PERSONAL_INFO}`);
    return `${authorRoot}${page}.html`;
};

export const withLocale = url => {
    if (!url) return url;

    const { origin, pathname } = window.location;
    // e.g. /cca/personal-information/ -> https://<host>/cca/personal-information/
    const target = new URL(url, origin);

    // e.g. https://na2.docusign.net/..., /login/, /myaccount/quotes/ -> returned as is
    if (target.origin !== origin || isAccountPath(target.pathname)) return url;

    // The language selector page is English only, e.g. /createaccount/language-selector/ never gets /fr-ca
    const isEnglishOnly = target.pathname.includes(LANGUAGE_SELECTOR_PATH);
    const authorRoot = getAuthorRoot(pathname);
    if (authorRoot) {
        // author, on .../language-masters/fr_ca/...: /cca/personal-information/ -> .../fr_ca/cca.html/personal-information
        target.pathname = toAuthorPath(target.pathname, isEnglishOnly ? `${LANGUAGE_MASTERS}en` : authorRoot);
    } else if (isFrCa(pathname) && !isEnglishOnly && !isFrCa(target.pathname) && !target.pathname.startsWith('/content/')) {
        // publish, on /fr-ca/...: /cca/personal-information/ -> /fr-ca/cca/personal-information/
        // skipped for English pages, /fr-ca/... targets (no double prefix) and /content/... paths
        target.pathname = `/${getLocale(pathname)}${target.pathname}`;
    }
    return target.toString();
};

// e.g. redirectWithLocale('/cca/personal-information/') -> location.href
// redirectWithLocale('/cca/personal-information/', true) -> location.replace (no back history)
export const redirectWithLocale = (url, isReplace = false) => {
    const target = withLocale(url);
    if (isReplace) window.location.replace(target);
    else window.location.href = target;
};
